function hasContent(str) {
  return str && str.trim() !== '';
}

function identicalIntegration(integration, lastSaved) {
  return JSON.stringify(integration) === JSON.stringify(lastSaved);
}

export function getMaxStep(integration, currentStep) {
  if (
    !hasContent(integration.plan.id) ||
    !hasContent(integration.form.id) ||
    !hasContent(integration.triggeredBy)
  ) {
    return 1;
  }
  if (
    !hasContent(integration.operation) ||
    (!hasContent(integration.environment) &&
      integration.operation !== 'SEND_TO_IA')
  ) {
    return 2;
  }
  if (integration.operation === 'RUN_SCRIPT') {
    if (
      integration.environment === 'ONPREMISE' &&
      (!integration.agents || integration.agents.length === 0)
    ) {
      return 2;
    }
    if (!hasContent(integration.name)) {
      return 3;
    }
    return 4;
  }
  if (integration.operation === 'SEND_WEBHOOK') {
    if (
      integration.environment === 'ONPREMISE' &&
      (!integration.agents || integration.agents.length === 0)
    ) {
      return 2;
    }
    if (!hasContent(integration.endpoint.id)) {
      return 2;
    }
    return 3;
  }
  if (integration.operation === 'SEND_TO_IA') {
    if (!hasContent(integration.integrationService)) {
      return 2;
    }
    return 3;
  }
  return currentStep;
}

export function canSave(integration, lastSaved, currentStep, totalSteps) {
  if (!totalSteps) {
    return false;
  }
  if (currentStep !== totalSteps) {
    return false;
  }
  if (hasContent(integration.name) && integration.operation !== 'RUN_SCRIPT') {
    return !identicalIntegration(integration, lastSaved);
  }
  if (
    integration.operation === 'RUN_SCRIPT' &&
    hasContent(integration.script)
  ) {
    return !identicalIntegration(integration, lastSaved);
  }
  return false;
}

export function getTotalStep(integration) {
  if (integration == null || !hasContent(integration.operation)) {
    return null;
  }
  if (integration.operation === 'RUN_SCRIPT') {
    return 4;
  }
  return 3;
}
